import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_BENEFICIARIES from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateBeneficiary = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, beneficiaryUuid, ...body }) => {
            return client.put(
                replaceParameters(PAYLUDD_BENEFICIARIES.UPDATE_PAYLUDD_BENEFICIARY.url, {
                    contractAccessId,
                    beneficiaryUuid
                }),
                body
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateBeneficiary;

